import {createSelector} from 'reselect';
import WebLoyaltyVersion from '../../enums/WebLoyaltyVersion';
import getPrivacyConsentFromPrivacyGroup from '../selectors/RoktSelectors/getPrivacyConsentFromPrivacyGroup';
import {getSettings} from '../selectors/selectors';
import getWebLoyaltyCountryCode from './getWebLoyaltyCountryCode';

export default createSelector(
  [getPrivacyConsentFromPrivacyGroup, getSettings, getWebLoyaltyCountryCode],
  (privacyConsent, settings, countryCode) => {
    if (privacyConsent && settings.web_loyalty_match && countryCode
      && settings.web_loyalty_match[countryCode.toLowerCase()]) {
      return WebLoyaltyVersion.WEBLOYALTY_MATCH;
    }
    
    if (settings.new_web_loyalty && countryCode && settings.new_web_loyalty[countryCode.toLowerCase()]) {
      return WebLoyaltyVersion.WEBLOYALTY_DEFAULT;
    }
    
    return '';
  },
);
